import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { baseUrl, subjectCategoryOptions } from "../../../Utility/constants";
import "react-toastify/dist/ReactToastify.css";
import { FaList } from 'react-icons/fa';
import { toast } from "react-toastify";
import { SubjectCategoryMasterEndpoint } from "../../../Utility/Endpoints";

const AddStudentOtherDetailsModal = ({
  selectedStudentId,
  schoolId,
  showOtherDetails,
  handleCloseOtherDetails,
  handleSubmitOtherDetails,
}) => {
  const studnetRole = localStorage.getItem("Role").toUpperCase();
  // API URLs
  const studentTypeApiUrl = `${baseUrl}/api/CommonMaster/GetStudentTypeMasters`;
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const sectionApiUrl = `${baseUrl}/api/SectionMaster/GetSectionByStandardID`;
  const studentDetailsApiUrl = `${baseUrl}/api/StudentOtherDetails/GetStudentOtherDetailsByStudentId`;
  const studentGroupTypeApiUrl = `${baseUrl}/api/SubjectGroupMaster`;
  const boardMasterApiUrl = `${baseUrl}/api/BoardMaster`;

  const [selectedStandardId, setSelectedStandardId] = useState("");
  const [selectedStandardText, setSelectedStandardText] = useState("");
  const [studentTypes, setStudentTypes] = useState([]);
  const [studentGroupTypes, setStudentGroupTypes] = useState([]);
  const [standards, setStandards] = useState([]);
  const [streams, setStreams] = useState([]);
  const [sections, setSections] = useState([]);
  const [earlyReleaseRemarks, setEarlyReleaseRemarks] = useState([]);

  const [boardMaster, setboardMaster] = useState([]);
  const [categories, setCategories] = useState([]);
  const [standardValue, setStandardValue] = useState('');
  const [grantTypes, setGrantTypes] = useState([]);
  const [schoolMediums, setSchoolMediums] = useState([]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(SubjectCategoryMasterEndpoint);
      setCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch categories");
    }
  };

  useEffect(() => {
    const fetchGrantTypes = async () => {
      try {
        const response = await axios.get(
          // `${baseUrl}/api/CommonMaster/GetGrantTypeMasters`
          `${baseUrl}/api/CommonMaster/GetGrantTypeMastersBySchoolId/${schoolId}`
        );
        setGrantTypes(response.data);
      } catch (error) {
        console.error("Error fetching Grant Types", error);
      }
    };
    fetchGrantTypes();
  }, []);

  const [newStudentItem, setNewStudentItem] = useState({
    StudentId: selectedStudentId,
    PreviousSchoolName: "",
    Board: "",
    StreamId: "",
    StandardId: "",
    SectionId: "",
    StudentTypeId: "",
    PhotoImage: null,
    SignImage: null,
    UploadedDocumentImage: null,
    AdmissionDate: "",
    GeneralRegisterNo: "",
    RollNo: "",
    SourceOfAdmission: "",
    Subjects: "",
    UDISENo: "",
    StudentSaralId: "",
    PermanentEducationNumber: "",
    apaarId: "",
    previousStandard: "",
    previousStream: "",
    StudentGroupId: "",
    EarlyRelease: false,
    EarlyReleaseDate: "",
    CreatedBy: localStorage.getItem("userID"),
    UpdatedBy: localStorage.getItem("userID"),
    previousStandardPercentage: '',
    previousAttendancePercentage: '',
    ExamSeatNo: '',
    DistanceOfStudentResidence: '',
    EarlyReleaseDate: "",
    GrantTypeID: "",
    StudentMediumId: "",
  });

  // Subject Selection 
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectModalShow, setSubjectModalShow] = useState(false);
  const [selectedSubjectNames, setSelectedSubjectNames] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (subjects.length > 0) {
      // Get all compulsory subject IDs
      const compulsorySubjects = subjects
        .filter(s => s.subjectCategoryName === "Compulsory")
        .map(s => s.subjectId);

      // Add compulsory subjects to selectedSubjects (if not already)
      setSelectedSubjects(prev => Array.from(new Set([...prev, ...compulsorySubjects])));
    }
  }, [subjects]);

  useEffect(() => {
    // Convert stored subject IDs to names when opening popup
    if (newStudentItem.Subjects) {
      const subjectIds = newStudentItem.Subjects.split(",").map(Number); // Convert string to array of numbers
      setSelectedSubjects(subjectIds);
      // Convert IDs to subject names for display
      const selectedNames = subjects
        .filter((subj) => subjectIds.includes(subj.subjectId))
        .map((subj) => subj.subjectName)
        .join(", ");

      setSelectedSubjectNames(selectedNames);
    }
  }, [newStudentItem.Subjects, subjects]);

  useEffect(() => {
    // Fetch stream details
    axios
      .get(`${baseUrl}/api/StreamMaster`)
      .then((response) => setStreams(response.data))
      .catch(() => console.log("Error fetching stream details"));

    // Fetch school medium details
    axios
      .get(`${baseUrl}/api/CommonMaster/GetSchoolMediumsBySchoolId/${schoolId}`)
      .then((response) => setSchoolMediums(response.data))
      .catch(() => console.log("Error fetching school medium details"));

    // Fetch student types
    axios
      .get(studentTypeApiUrl)
      .then((response) => setStudentTypes(response.data))
      .catch(() => console.log("Error fetching student types"));

    // Fetch student group types
    axios
      .get(studentGroupTypeApiUrl)
      .then((response) => setStudentGroupTypes(response.data))
      .catch(() => console.log("Error fetching student group types"));

    // Fetch board masters
    axios
      .get(boardMasterApiUrl)
      .then((response) => setboardMaster(response.data))
      .catch(() => console.log("Error fetching board masters"));

    // Fetch Early Release Remarks
    axios
      .get(`${baseUrl}/api/EarlyReleaseRemark`)
      .then((response) => setEarlyReleaseRemarks(response.data))
      .catch(() => console.log("Error fetching EarlyReleaseRemark"));

    fetchCategories();
  }, []);

  useEffect(() => {
    if (!selectedStudentId) return;

    axios.get(`${studentDetailsApiUrl}?id=${selectedStudentId}`)
      .then((response) => {
        const details = response.data;
        setSelectedStandardId(details.StandardId);
        setSelectedStandardText(details.StandardName);
        setNewStudentItem({
          ...newStudentItem,
          StudentId: details.StudentId,
          PreviousSchoolName: details.PreviousSchoolName,
          Board: details.Board,
          UDISENo: details.UDISENo,
          StudentSaralId: details.StudentSaralId,
          PermanentEducationNumber: details.PermanentEducationNumber,
          AdmissionDate: details.AdmissionDate ? details.AdmissionDate.split("T")[0] : "",
          GeneralRegisterNo: details.GeneralRegisterNo,
          RollNo: details.RollNo,
          SourceOfAdmission: details.SourceOfAdmission,
          Subjects: details.Subjects,
          StandardId: details.StandardId,
          StreamId: details.StreamId,
          SectionId: details.SectionId,
          StudentTypeId: details.StudentTypeId,
          apaarId: details.APAARId,
          previousStandard: details.PreviousStandard,
          previousStream: details.PreviousStream,
          StudentGroupId: details.StudentGroupId,
          EarlyRelease: details.EarlyRelease,
          EarlyReleaseDate: details.EarlyReleaseDate ? details.EarlyReleaseDate.split("T")[0] : "",
          ExamSeatNo: details.ExamSeatNo,
          previousStandardPercentage: details.PreviousStandardPercentage,
          previousAttendancePercentage: details.PreviousAttendancePercentage,
          DistanceOfStudentResidence: details.DistanceOfStudentResidence,
          EarlyReleaseRemarksId: details.EarlyReleaseRemarksId,
          GrantTypeID: details.GrantTypeID,
          StudentMediumId: details.StudentMediumId ?? details.StudentMediumId ?? "",
        });
      })
      .catch(() => console.log("Error fetching student details"));
  }, [selectedStudentId]);

  // Fetch standards based on schoolId
  useEffect(() => {
    if (schoolId) {
      axios
        .get(`${standardApiUrl}?id=${schoolId}`)
        .then((response) => setStandards(response.data))
        .catch(() => console.log("Error fetching standards"));
    }
  }, [schoolId]);

  useEffect(() => {
    const fetchSubjectsForAdmin = async () => {
      if (!newStudentItem.StandardId) return;
      if (!newStudentItem.StreamId) return;
      if (!newStudentItem.StudentGroupId) return;

      const params = new URLSearchParams({
        classId: newStudentItem.StandardId,
        streamId: newStudentItem.StreamId || "",
        subjectGroup: newStudentItem.StudentGroupId || ""
      });

      try {
        const response = await axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?${params}`);
        setSubjects(response.data);

        if (newStudentItem.Subjects) {
          const subjectIds = newStudentItem.Subjects.split(",").map(Number);
          setSelectedSubjects(subjectIds);

          const selectedNames = response.data
            .filter((s) => subjectIds.includes(s.subjectId))
            .map((s) => s.subjectName)
            .join(", ");
          setSelectedSubjectNames(selectedNames);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchSubjectsForAdmin();
  }, [newStudentItem.StandardId, newStudentItem.StreamId, newStudentItem.StudentGroupId]);


  // Fetch sections based on selected standard ID
  useEffect(() => {
    if (selectedStandardId) {
      axios
        .get(`${sectionApiUrl}?id=${selectedStandardId}`)
        .then((response) => setSections(response.data))
        .catch(() => console.log("Error fetching sections"));
      setSelectedStandardId(selectedStandardId);
    }
  }, [selectedStandardId]);

  const handleInputChange = (e) => {
    debugger;
    const { name, value, type, checked } = e.target;
    let isValid = true;
    // If the date is valid or if it's not the AdmissionDate field, proceed with updating the state
    if (isValid) {
      if (name === "StandardId") {
        setSelectedStandardId(value);
        setSelectedStandardText(e.target.options[e.target.selectedIndex].text);
        setStandardValue(e.target.options[e.target.selectedIndex].text);
      }

      setNewStudentItem((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Personal Details
    if (selectedStandardText > 10) {
      if (!newStudentItem.StreamId) newErrors.StreamId = "Stream is required.";
    }
    if (!newStudentItem.StandardId) newErrors.StandardId = "Standard is required.";
    //if (!newStudentItem.UDISENo) newErrors.UDISENo = "UDISENo is required.";

    if (!newStudentItem.GrantTypeID) newErrors.GrantTypeID = "Grant Type is required.";

    if (selectedStandardText !== "1") {
      if (!newStudentItem.previousStandardPercentage)
        newErrors.previousStandardPercentage = "Previous Standard Percentage is required.";

      if (!newStudentItem.PreviousSchoolName) newErrors.PreviousSchoolName = "Previous School Name is required.";
      if (!newStudentItem.Board) newErrors.Board = "Board is required.";
    }
    //if (!newStudentItem.previousAttendancePercentage) newErrors.previousAttendancePercentage = "Previous Attendance Percentage is required.";
    if (!selectedSubjectNames) newErrors.selectedSubjectNames = " Subject is required.";

    setErrors(newErrors);
    return newErrors;

  }

  // Handle form submit
  const handleFormSubmit = (e) => {

    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      newStudentItem.StudentId = selectedStudentId;
      newStudentItem.CreatedBy = localStorage.getItem("userID");
      newStudentItem.UpdatedBy = localStorage.getItem("userID");
      newStudentItem.EarlyReleaseDate = newStudentItem.EarlyRelease === false ? null : newStudentItem.EarlyReleaseDate;
      handleSubmitOtherDetails(e, newStudentItem); // Pass data to parent component
    }
    else {
      Object.values(newErrors).forEach((err) => {
        toast.error(err);
      });
    }
  };

  // Subject Selection 
  const loadSubjects = async (openSubjectsModal) => {

    // Validation
    if (Number(standardValue) > 10) {
      if (!(newStudentItem.StandardId && newStudentItem.StreamId && newStudentItem.StudentGroupId)) {
        toast.warning("Standard, stream and subject group type are required to fetch subjects.");
        return;
      }
    } else {
      if (!newStudentItem.StandardId) {
        toast.warning("Standard is required to fetch subjects.");
        return;
      }
    }

    try {
      const params = new URLSearchParams({
        classId: newStudentItem.StandardId,
        streamId: newStudentItem.StreamId || "",
        subjectGroup: newStudentItem.StudentGroupId || ""
      });

      const subjectUrl = `${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?${params}`;
      const response = await axios.get(subjectUrl);

      // Sort subjects by configured category order
      const sortedSubjects = categories.flatMap(category =>
        response.data
          .filter(subject => parseInt(subject.subjectCategoryId) === category.subjectCategoryID)
          .map(subject => ({
            ...subject,
            subjectCat: category.subjectCategoryName,
          }))
      );

      // Automatically select compulsory subjects
      const compulsoryIds = sortedSubjects
        .filter(s => s.subjectCategoryName === "Compulsory")
        .map(s => s.subjectId);

      setSelectedSubjects(prev => Array.from(new Set([...prev, ...compulsoryIds]))); // Merge with existing selections
      setSubjects(sortedSubjects);

      if (sortedSubjects.length > 0 && openSubjectsModal) {
        setSubjectModalShow(true);
      }
    } catch (error) {
      console.error("Error fetching subjects", error);
    }
  };

  const handleSubjectFetchAndShow = async () => {
    await loadSubjects(true);
    setSubjectModalShow(true);
  };

  const handleSubjectSelection = (subject) => {
    setSelectedSubjects((prev) => {
      // If already selected, remove it
      if (prev.includes(subject.subjectId)) return prev.filter(id => id !== subject.subjectId);

      // Count how many subjects are already selected in this category
      const categorySelectedCount = subjects
        .filter(s => s.subjectCategoryName === subject.subjectCategoryName)
        .filter(s => prev.includes(s.subjectId)).length;

      // Check maxLimit
      if (subject.subjectCategoryName !== "Compulsory" && categorySelectedCount >= subject.subjectMaxLimit) {
        toast.warning(`You can select maximum ${subject.subjectMaxLimit} subject(s) in ${subject.subjectCategoryName}`);
        return prev; // do not add
      }

      // Add subject
      return [...prev, subject.subjectId];
    });
  };

  const handleSaveSubjects = () => {

    const selectedSubjectIds = subjects
      .filter(subject => selectedSubjects.includes(subject.subjectId))
      .map(subject => subject.subjectId)
      .join(",");

    const selectedNames = subjects
      .filter(subject => selectedSubjects.includes(subject.subjectId))
      .map(subject => subject.subjectName)
      .join(", ");
    setSelectedSubjectNames(selectedNames);

    setNewStudentItem({
      ...newStudentItem,
      Subjects: selectedSubjectIds, // ✅ ONLY selected IDs
    });

    //setSelectedSubjects(selectedSubjects);
    setSubjectModalShow(false);
  };

  return (
    <Modal
      show={showOtherDetails}
      onHide={handleCloseOtherDetails}
      dialogClassName="custom-modal-lg"
      centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Other Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleFormSubmit}>
          <Row className="mb-3">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={8} className="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                    <h4>Admission Details</h4></td>
                </tr>
              </tbody></table>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Student Type</Form.Label>
                <Form.Control
                  as="select"
                  name="StudentTypeId"
                  value={newStudentItem.StudentTypeId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Student Type</option>
                  {studentTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Admission Date</Form.Label>
                <Form.Control
                  type="date"
                  name="AdmissionDate"
                  value={newStudentItem.AdmissionDate || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group controlId="formGrantType">
                <Form.Label>Grant Type</Form.Label>
                <Form.Control
                  as="select"
                  name="GrantTypeID"
                  // multiple
                  value={newStudentItem.GrantTypeID || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Grant Type</option>
                  {grantTypes.map((grant) => (
                    <option key={grant.id} value={grant.id}>
                      {grant.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group controlId="formStudentMediumId">
                <Form.Label>School Medium</Form.Label>
                <Form.Control
                  as="select"
                  name="StudentMediumId"
                  value={newStudentItem.StudentMediumId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select School Medium</option>
                  {schoolMediums.map((medium) => (
                    <option key={medium.id} value={medium.id}>
                      {medium.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Standard <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="StandardId"
                  value={newStudentItem.StandardId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Standard</option>
                  {standards.map((standard) => (
                    <option key={standard.id} value={standard.id}>
                      {standard.standardName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Section</Form.Label>
                <Form.Control
                  as="select"
                  name="SectionId"
                  value={newStudentItem.SectionId || ""}
                  onChange={handleInputChange}
                  disabled={studnetRole === "STUDENT" ? true : false}
                >
                  <option value="">Select Section</option>
                  {sections.map((section) => (
                    <option key={section.id} value={section.id}>
                      {section.name}
                    </option>
                  ))}
                  disabled={studnetRole === "STUDENT"}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Streams {standardValue && Number(standardValue) > 10 ?
                    <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>
                <Form.Control
                  as="select"
                  name="StreamId"
                  value={newStudentItem.StreamId || ""}
                  onChange={handleInputChange}
                  disabled={standardValue && Number(standardValue) <= 10}
                >
                  <option value="">Select Stream</option>
                  {streams.map((stream) => (
                    <option key={stream.id} value={stream.id}>
                      {stream.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Subject GroupType</Form.Label>
                <Form.Control
                  as="select"
                  name="StudentGroupId"
                  value={newStudentItem.StudentGroupId || ""}
                  onChange={handleInputChange}
                disabled={
                  (standardValue && Number(standardValue) <= 10) ||
                  studnetRole === "STUDENT"
                }
                >
                  <option value="">Select GroupType</option>
                  {studentGroupTypes.map((type) => (
                    <option key={type.subjectGroupId} value={type.subjectGroupId}>
                      {type.subjectGroupName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>General Register No</Form.Label>
                <Form.Control
                  type="text"
                  name="GeneralRegisterNo"
                  value={newStudentItem.GeneralRegisterNo || ""}
                  onChange={handleInputChange}
                  disabled={true}
                />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Form.Group>
                <Form.Label>Roll No</Form.Label>
                <Form.Control
                  type="text"
                  name="RollNo"
                  value={newStudentItem.RollNo || ""}
                  onChange={handleInputChange}
                  // disabled={studnetRole === "STUDENT" ? true : false}
                  disabled={true}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Exam Seat No</Form.Label>
                <Form.Control
                  type="text"
                  name="ExamSeatNo"
                  value={newStudentItem.ExamSeatNo || ""}
                  onChange={handleInputChange}
                  // disabled={studnetRole === "STUDENT" ? true : false}
                  disabled={true}
                />
              </Form.Group>
            </Col>
            {/* </Row>

          <Row className="mb-3"> */}
            <Col md={5}>
              <Form.Group>
                <Form.Label>Subjects <span style={{ color: 'red' }}>*</span> &nbsp;&nbsp;&nbsp;
                  <FaList
                    style={{
                      cursor: studnetRole === "STUDENT" ? "not-allowed" : "pointer",
                      marginLeft: "10px",
                      opacity: studnetRole === "STUDENT" ? 0.5 : 1
                    }}
                    onClick={
                      () => handleSubjectFetchAndShow(true)
                    }
                  /><span style={{ cursor: "pointer" }}>&nbsp;Click here to add subject</span> </Form.Label>
                <Form.Control
                  type="text"
                  name="Subjects"
                  value={selectedSubjectNames || ""}
                  onChange={handleInputChange}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={8} className="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                    <h4>Previous School Details</h4></td>
                </tr>
              </tbody></table>
            <Col md={2}>
              <Form.Group>
                <Form.Label>UDISE No
                  {/* <span style={{ color: 'red' }}>*</span> */}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="UDISENo"
                  value={newStudentItem.UDISENo || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              {" "}
              <Form.Group>
                <Form.Label>Previous Standard</Form.Label>
                <Form.Control
                  as="select"
                  name="previousStandard"
                  value={newStudentItem.previousStandard || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Standard</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              {" "}
              <Form.Group>
                <Form.Label>Previous Stream</Form.Label>
                <Form.Control
                  as="select"
                  name="previousStream"
                  value={newStudentItem.previousStream || ""}
                  onChange={handleInputChange}
                  disabled={standardValue && Number(standardValue) <= 10}
                >
                  <option value="">Select Previous Stream</option>
                  {streams.map((stream) => (
                    <option key={stream.id} value={stream.id}>
                      {stream.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              {" "}
              <Form.Group>
                <Form.Label>Previous Standard % <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="previousStandardPercentage"
                  value={newStudentItem.previousStandardPercentage || ""}
                  onChange={handleInputChange}
                  maxLength={12}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              {" "}
              <Form.Group>
                <Form.Label>No. of Days School Attended
                  {/* <span style={{ color: 'red' }}>*</span> */}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="previousAttendancePercentage"
                  value={newStudentItem.previousAttendancePercentage || ""}
                  onChange={handleInputChange}
                  maxLength={12}
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Student Saral Id / PEN</Form.Label>
                <Form.Control
                  type="text"
                  name="StudentSaralId"
                  value={newStudentItem.StudentSaralId || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            {/* <Col md={2} style={{ display: 'none' }}>
              <Form.Group>
                <Form.Label>Permanent Education Number</Form.Label>
                <Form.Control
                  type="text"
                  name="PermanentEducationNumber"
                  value={newStudentItem.PermanentEducationNumber || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col> */}
            <Col md={2}>
              <Form.Group>
                <Form.Label>APAAR ID</Form.Label>
                <Form.Control
                  type="text"
                  name="apaarId"
                  value={newStudentItem.apaarId || ""}
                  onChange={handleInputChange}
                  maxLength={12}
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Previous School Name <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="PreviousSchoolName"
                  value={newStudentItem.PreviousSchoolName || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Board<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="Board"
                  value={newStudentItem.Board || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Board</option>
                  {boardMaster.map((board) => (
                    <option key={board.boardId} value={board.boardId}>
                      {board.boardName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Source of Admission</Form.Label>
                <Form.Control
                  type="text"
                  name="SourceOfAdmission"
                  value={newStudentItem.SourceOfAdmission || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Distance</Form.Label>
                <Form.Control
                  type="text"
                  name="DistanceOfStudentResidence"
                  value={newStudentItem.DistanceOfStudentResidence || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            {studnetRole !== "STUDENT" &&
              <>
                <Col md={2}>
                  <br></br>
                  <Form.Group>
                    <Form.Group controlId="formEarlyRelease">
                      <Form.Check
                        type="checkbox"
                        name="EarlyRelease"
                        checked={!!newStudentItem.EarlyRelease}
                        onChange={handleInputChange}
                        label="Early Release"
                      />
                    </Form.Group>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group controlId="formEarlyReleaseDate">
                    <Form.Label>Early Release Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="EarlyReleaseDate"
                      value={
                        newStudentItem.EarlyReleaseDate
                          ? newStudentItem.EarlyReleaseDate.split("T")[0]
                          : ""
                      }
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Early Release Remarks</Form.Label>
                    <Form.Control
                      as="select"
                      name="EarlyReleaseRemarksId"
                      value={newStudentItem.EarlyReleaseRemarksId || ""}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Early Release Remarks</option>
                      {earlyReleaseRemarks.map((remark) => (
                        <option key={remark.id} value={remark.id}>
                          {remark.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </>
            }

          </Row>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseOtherDetails}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>

        {/* Subject Selection Modal */}
        <Modal show={subjectModalShow} onHide={() => setSubjectModalShow(false)}
          dialogClassName="custom-modal-md">
          <Modal.Header closeButton>
            <Modal.Title>Choose Subjects</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {(() => {
                if (!subjects.length) return <p>No subjects available</p>;

                // Get unique category names from subjects
                const categoryNames = [...new Set(subjects.map(s => s.subjectCategoryName))];

                // Optional priority map for ordering
                const priority = { Compulsory: 1, Optional: 2, Language: 3 };
                const sortedCategories = categoryNames.sort((a, b) => {
                  const pa = priority[a] ?? 99;
                  const pb = priority[b] ?? 99;
                  return pa - pb || a.localeCompare(b);
                });

                // Group subjects by category
                const groupedSubjects = sortedCategories.map(cat => {
                  const group = subjects.filter(s => s.subjectCategoryName === cat);
                  const { subjectCategoryConfigName, subjectMaxLimit } = group[0];
                  return {
                    category: cat,
                    configName: subjectCategoryConfigName,
                    maxLimit: subjectMaxLimit,
                    items: group
                  };
                });

                return groupedSubjects.map(group => (
                  <div key={group.category} className="mb-4">
                    <h5 className="mb-3">
                      {group.category} - {group.configName} ({group.maxLimit === 0 ? 'All' : group.maxLimit})
                    </h5>
                    {Array.from({ length: Math.ceil(group.items.length / 3) }).map((_, rowIdx) => (
                      <Row key={rowIdx} className="mb-2">
                        {group.items
                          .slice(rowIdx * 3, rowIdx * 3 + 3)
                          .map(subject => (
                            <Col md={4} key={subject.subjectId}>
                              <Form.Check
                                type="checkbox"
                                label={subject.subjectName}
                                checked={selectedSubjects.includes(subject.subjectId)}
                                disabled={subject.subjectCategoryName === "Compulsory"}
                                onChange={() => handleSubjectSelection(subject)}
                              />
                            </Col>
                          ))}
                      </Row>
                    ))}
                  </div>
                ));
              })()}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleSaveSubjects}>Save Subjects</Button>
          </Modal.Footer>
        </Modal>

      </Modal.Body>
    </Modal>
  );
};

export default AddStudentOtherDetailsModal;